import { type Session } from '@/types';
import { Typography } from '@/ui';

import type { FC } from 'react';

import CancellationControls from '@/components/Sessions/Member/CancellationControls';

interface SectionProps {
  hideCalendarOptions?: boolean; // no point showing reschedule or cancel on past sessions
  session: Session;
  title: string;
}

const Card: FC<SectionProps> = ({ title, session, hideCalendarOptions }) => (
  <>
    <Typography className="mb-2" variant="subtitle1">
      {title}
    </Typography>
    <CancellationControls
      hideCalendarOptions={hideCalendarOptions}
      session={session}
    />
  </>
);

export default Card;
